var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInUp", delay: 0, duration: 300 },
          expression: "{ classes: 'slideInUp', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "chat-widget",
    },
    [
      _c("section", { staticClass: "header" }, [
        _c(
          "span",
          {
            staticClass: "material-icons text-info",
            staticStyle: { "font-size": "50px" },
          },
          [_vm._v(" chat ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c(
            "strong",
            {
              staticClass: "font-weight-bold",
              staticStyle: { "font-size": "25px", "letter-spacing": "1.5px" },
            },
            [_vm._v("Chat Bot")]
          ),
          _vm._v(" "),
          _c(
            "small",
            { staticClass: "text-success" },
            [
              _c("a-badge", { attrs: { color: "green" } }),
              _vm._v("\n                Online\n            "),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "md-button",
              { staticClass: "md-icon-button" },
              [_c("md-icon", [_vm._v("more_vert")])],
              1
            ),
            _vm._v(" "),
            _c(
              "md-button",
              { staticClass: "md-icon-button", on: { click: _vm.closeWidget } },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "chat-conversation" }, [
        _c(
          "div",
          { staticClass: "conversation" },
          [
            _vm.getMessages().length
              ? _c("MessageList", {
                  attrs: {
                    "should-scroll": false,
                    "always-scroll-to-bottom": true,
                    colors: _vm.colors,
                    messages: _vm.getMessages(),
                    participants: _vm.participants,
                    "scroll-top": true,
                    "is-private-chat": true,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "footer" },
        [
          _c("UserInput", {
            attrs: {
              id: "privateChatUserInput",
              colors: _vm.colors,
              onSubmit: _vm.sendMessage,
              placeholder: _vm.$t("message.typeHere"),
              showEmoji: true,
              showFile: false,
              disabled:
                _vm.closed || !_vm.$_.get(this.sezar, "userInputAllowed", true),
              "new-icon": true,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.openMoment.visible
        ? _c("InFrame", {
            attrs: { url: _vm.openMoment.url, size: _vm.openMoment.size },
            on: {
              close: function ($event) {
                _vm.openMoment.visible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }